module.exports = __webpack_public_path__ + "img/supralift-topseller.76265eb1.png";